import { AstraCallout } from '~/astra'
import { dispatchSuccessToast } from '~/store/slices/toasterSlice'
import { useDipsResourceById } from '~/storm'

import { dispatchFirstError } from '../../Form/formErrors'
import { FormPageWrapper } from '../../Form/FormWrapper'
import { useResourceNavigation } from '../../useResourceNavigation'
import { type LocationFormParsedValues } from './formState'
import { LocationForm } from './LocationForm'
import { saveNewLocation } from './saveLocation'

export const NewLocation = () => {
    const { dipsResourceId, navigateToList } = useResourceNavigation()
    const dipsResourceLookup = useDipsResourceById(dipsResourceId)
    const dipsResource = dipsResourceId !== null ? dipsResourceLookup : null

    const handleSubmit = async (values: LocationFormParsedValues) => {
        const results = await saveNewLocation(values)
        const error = dispatchFirstError(results)
        if (error) return
        dispatchSuccessToast('Stuen er opprettet')
        await navigateToList()
    }

    return (
        <FormPageWrapper backCrumb={{ title: 'Stuer', onClick: () => void navigateToList() }}>
            {dipsResource?.shortName ? (
                <LocationForm
                    title={`Legg til ${dipsResource.shortName} i Hero`}
                    initialValues={{
                        roomCode: dipsResource.shortName,
                        dipsId: String(dipsResource.id),
                    }}
                    isNew
                    onSubmit={handleSubmit}
                />
            ) : (
                <AstraCallout
                    text="Fant ikke spesifisert stue."
                    color="critical"
                    action={{ label: 'Tilbake til liste', onClick: () => void navigateToList() }}
                />
            )}
        </FormPageWrapper>
    )
}
